<template>
  <div style="height: calc(100vh - 120px);">
    <listToolbar :toolbar="toolbar" @toolTap="toolTap" @addTap="addTap" />
    <listTable
      :list="list"
      :page="page"
      :loading="loading"
      :total="total"
      :pageSize="pageSize"
      :columns="columns"
      @page-change="pageChange" />
    <el-drawer v-model="formDrawerVisible" size="30%" :title="typeForm === 'add'? '添加' : '修改'">
      <div v-if="formDrawerVisible" style="padding-left: 16px; padding-right: 16px;">
        <Form :columns="addColumns" :type="typeForm" @submit="submit" />
      </div>
    </el-drawer>
    <el-drawer v-model="formDrawerVisible2" size="30%" title="详情">
      <div v-if="formDrawerVisible2" style="padding-left: 16px; padding-right: 16px;">
        <formSee :columns="addColumnsDet" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { courseList, packageDel, packageList, packageStatus, packageSubmit } from '@/apis/common'
import listToolbar from '@/components/system/listToolbar.vue'
import listTable from '@/components/system/listTable.vue'
import Form from '@/components/system/form.vue'
import formSee from '@/components/system/formSee.vue'

export default {
  name: 'package',
  components: { formSee, Form, listTable, listToolbar },
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem('user')) || {},
      page: 1,
      pageSize: 15,
      total: 0,
      loading: false,
      formData: {
        package_name: '',
        course_name: '',
        validity: '',
        status: ''
      },
      toolbar: [
        {type: 'input', label: '课包名称', model: 'package_name', value: ''},
        {type: 'input', label: '课程名称', model: 'course_name', value: ''},
        {type: 'select', label: '课程有效期', model: 'validity', value: '', options: [
            {label: '全部', value: ''},
            {label: '永久', value: '0'},
            {label: '限期', value: '1'},
          ]},
        {type: 'select', label: '状态', model: 'status', value: '', options: [
            {label: '全部', value: ''},
            {label: '上架', value: '1'},
            {label: '下架', value: '0'},
          ]},
        {type: 'button', label: '搜索', icon: 'el-icon-search', def: 'default', key: 'search'},
        {type: 'button', label: '添加', def: 'primary',key: 'add'}
      ],
      list: [],
      columns: [
        {label: '套餐ID', prop: 'id', width: 100, type: 'text'},
        {label: '套餐名称', prop: 'package_name', width: 150, type: 'text'},
        {label: '课程', prop: 'course_id', width: 100, type: 'json', deputy: 'course'},
        {label: '单价', prop: 'price', width: 80, type: 'text'},
        {label: '数量', prop: 'num', width: 80, type: 'text'},
        {label: '原价', prop: 'old_price', width: 80, type: 'text'},
        {label: '现价', prop: 'now_price', width: 80, type: 'text'},
        {label: '折扣', prop: 'discount', width: 80, type: 'text'},
        {label: '状态', prop: 'status', width: 80, type: 'switch', change: (e,v) => this.changeStatus(e,v)},
        {label: '有效期', prop: 'validity', width: 80,  type: 'tag',  arr: [{key: 0,type: 'success', label: '永久'}, {key: 1,type: 'success', label: '限期'}]},
        {label: '到期日期', prop: 'end_date', width: 150, type: 'text'},
        {label: '创建时间', prop: 'created_at', width: 150, type: 'text'},
        {label: '备注', prop: 'note', width: 150, type: 'text'},
        {label: '操作', width: 260, type: 'but', arr: [
            {type: 'default', icon: 'el-icon-document', label: '查看', onClick: (row) => this.seeDetails(row)},
            {type: 'primary', icon: 'el-icon-edit', label: '修改', onClick: (row) => this.modify(row)},
            {type: 'danger', icon: 'el-icon-delete', label: '删除', onClick: (row) => this.del(row)}
          ]}
      ],
      formDrawerVisible: false,
      formDrawerVisible2: false,
      typeForm: 'add',
      addColumns: [
        {label: '套餐名称', prop: 'package_name', type: 'input',value: ''},
        {label: '课程', prop: 'course_id', type: 'select', value: '',options: []},
        {label: '单价', prop: 'price', type: 'input',value: ''},
        {label: '数量', prop: 'num', type: 'input',value: ''},
        {label: '原价', prop: 'old_price', type: 'input',value: ''},
        {label: '现价', prop: 'now_price', type: 'input',value: ''},
        {label: '课程有效期', prop: 'validity', linkage: 'one', main: true, type: 'select', value: '',options: [
            {label: '永久', value: 0},
            {label: '限期', value: 1},
          ]},
        {label: '到期日期', prop: 'end_date', linkage: 'one', linkageValue: '1', type: 'date',value: ''},
        {label: '图片', prop: 'picurl', type: 'img',value: '', limit: 1},
        {label: '备注', prop: 'note', type: 'input',value: ''},
      ],
      addFormData: {},
      addColumnsDet: [
        {label: '套餐名称', prop: 'package_name', type: 'input',value: ''},
        {label: '单价', prop: 'price', type: 'input',value: ''},
        {label: '数量', prop: 'num', type: 'input',value: ''},
        {label: '原价', prop: 'old_price', type: 'input',value: ''},
        {label: '现价', prop: 'now_price', type: 'input',value: ''},
        {label: '折扣', prop: 'discount', type: 'input',value: ''},
        {label: '课程有效期', prop: 'validity', type: 'select', value: '',options: [
            {label: '永久', value: 0},
            {label: '限期', value: 1},
          ]},
        {label: '状态', prop: 'status', type: 'select', value: '',options: [
            {label: '上架', value: true},
            {label: '下架', value: false},
          ]},
        {label: '到期日期', prop: 'end_date', type: 'date',value: ''},
        {label: '创建时间', prop: 'created_at', type: 'date',value: ''},
        {label: '图片', prop: 'picurl', type: 'img',value: '', limit: 1},
        {label: '备注', prop: 'note', type: 'input',value: ''},
      ]
    }
  },
  mounted() {
    this.getPackageList()
    this.getCourseList()
  },
  methods: {
    getCourseList() {
      courseList({
        admin_id: this.info.id,
        agency_id: this.info.agency_school_id,
        school_id: 0,
      }).then(res => {
        this.addColumns[1].options = res.data.data.map(item => {
          return {
            label: item.name,
            value: item.id
          }
        })
      })
    },
    // 删除
    del(row) {
      this.addFormData = row
      this.$confirm('确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        packageDel({
          admin_id: this.info.id,
          agency_id: this.info.agency_school_id,
          school_id: 0,
          package_id: row.id
        }).then(res => {
          this.$message.success('删除成功')
          this.getPackageList()
        })
      }).catch(() => {})
    },
    // 查看
    seeDetails(row) {
      this.addColumnsDet.forEach(item => {
        item.value = row[item.prop]
      })
      this.formDrawerVisible2 = true
    },
    // 修改
    modify(row) {
      this.addFormData = row
      this.typeForm = 'edit'
      this.addColumns.forEach(item => {
        item.value = row[item.prop]
      })
      this.formDrawerVisible = true
    },
    submit(e,n) {
      let form = {
        admin_id: this.info.id,
        agency_id: this.info.agency_school_id,
        school_id: 0,
        package_id: n === 'edit' ? this.addFormData.id : '',
        ...e
      }
      packageSubmit(form).then(res => {
        this.formDrawerVisible = false
        this.$message.success('操作成功')
        this.getPackageList()
      })
    },
    changeStatus(e,v) {
      packageStatus({
        admin_id: this.info.id,
        agency_id: this.info.agency_school_id,
        school_id: 0,
        package_id: v.id,
        status: e ? 1 : 0
      }).then(res => {
      })
    },
    addTap() {
      this.addColumns.forEach(item => {
        item.value = ''
      })
      this.formDrawerVisible = true
      this.typeForm = 'add'
    },
    // 分页
    pageChange(e) {
      this.page = e
      this.getPackageList()
    },
    toolTap(data) {
      this.formData = data
      this.page = 1
      this.getPackageList()
    },
    getPackageList() {
      this.loading = true
      packageList({
        page: this.page,
        pagesize: this.pageSize,
        admin_id: this.info.id,
        agency_id: this.info.agency_school_id,
        school_id: 0,
        ...this.formData
      }).then(res => {
        this.total = res.data.data.count
        this.list = res.data.data.list.map(x => {
          x.status = x.status === 1
          return x
        })
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>
